import React, { useEffect, useState } from "react"
import { get } from "helpers/api_helper"

// The counter above the Events list: how many events have competitions without fees in the warning (Events Planner ticket 25), of
// the sport the gateway scopes the list to; it lists only them. A count that cannot be read says so; nothing shows while no event
// needs fees.
export default function EventsNeedingFees({ active, onShow, onShowAll }) {
  const [count, setCount] = useState(undefined), [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let alive = true
    setCount(undefined)
    get("/admin/events/needing-fees").then(response => {
      const value = response?.data?.count
      if (alive) setCount(Number.isInteger(value) && value >= 0 ? value : null)
    }).catch(() => { if (alive) setCount(null) })
    return () => { alive = false }
  }, [attempt])
  if (active) return <div className="events-needing-fees alert alert-danger d-flex flex-wrap align-items-center">
    <span className="mr-3">Showing the events that need fees.</span>
    <button type="button" className="btn btn-light btn-sm" onClick={onShowAll}>Show all events</button>
  </div>
  if (count === null) return <div className="events-needing-fees text-muted mb-3">The events that need fees could not be checked.
    <button type="button" className="btn btn-link btn-sm" onClick={() => setAttempt(value => value + 1)}>Check again</button></div>
  if (!count) return null
  return <div className="events-needing-fees mb-3">
    <button type="button" className="btn btn-outline-danger" onClick={onShow}>{count === 1 ? "1 event needs fees" : count + " events need fees"}</button>
    <small className="text-muted ml-2">Competitions without fees stay closed to registrations; the warning starts a week before they open.</small>
  </div>
}
